import { useEffect, useState } from "react";
import personaServicio from "../../services/persona/personaServicio";
import { IFilterEquipoBySupervisor } from "../../Interfaces/IEquipo";
import { InitialFilterSupervisores } from "../../utils/Initials/InitialPersonas";
import { IPaginacion } from "../../Interfaces/filter";
import { IEquipo } from "../../Interfaces/IListaVerificacion";

export const useTableEquipoBySupervisor = (id) => {
  const [filter, setFilter] = useState<IFilterEquipoBySupervisor>(
    InitialFilterSupervisores
  );
  const [paginacion, setPaginacion] = useState<IPaginacion>(null!);
  const [data, setData] = useState<IEquipo[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const dataEquipo = () => {
    filter.supervisorId = id;
    setIsLoading(true);
    personaServicio
      .getEquipoPorSupervisor(filter)
      .then((res) => {
        setData(res.data.data);
        setPaginacion({
          page: res.data.page,
          pages: res.data.pages,
          total: res.data.total,
        });
        setIsLoading(false);
      })
      .catch((e: Error) => {
        alert(e.message);
        setIsLoading(false);
      });
  };
  const onChangeSkip = (evento: string) => {
    switch (evento) {
      case "next":
        setFilter({ ...filter, skip: filter.skip + 1 });
        break;
      case "prev":
        setFilter({ ...filter, skip: filter.skip - 1 });
        break;

      default:
        break;
    }
  };

  useEffect(() => {
    dataEquipo();
  }, [filter, id]);

  return {
    data,
    paginacion,
    isLoading,
    onChangeSkip,
  };
};
